import { getFocusableElements } from "common/a11y";

/**
 * This utility exists because <ui-focus-trap> has some weird issues
 * with default <slot> content
 */
export function trapFocus(element: HTMLElement) {
  let focusFirst = () =>
    getFocusableElements(element)
      .slice(0, 1)
      .forEach((n) => n.focus());
  let focusLast = () =>
    getFocusableElements(element)
      .slice(-1)
      .forEach((n) => n.focus());
  let onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Tab") {
      let [target] = e.composedPath() as HTMLElement[];
      let elements = getFocusableElements(element);
      if (target.contains(elements[0]) && e.shiftKey) {
        e.preventDefault();
        focusLast();
      }
      if (target.contains(elements[elements.length - 1]) && !e.shiftKey) {
        e.preventDefault();
        focusFirst();
      }
    }
  };
  element.addEventListener("keydown", onKeyDown);
  setTimeout(focusFirst);
  return () => {
    element.removeEventListener("keydown", onKeyDown);
  };
}
